import { HomeDetails as SharedHomeDetails } from '@markku/components'
import type { selectPropertyWithAddressSchema } from '@markku/types'
import { z } from 'zod'
import { attachmentHooks } from '../../lib/trpcHooks/attachment'
import { propertyHooks } from '../../lib/trpcHooks/propertyHooks'
import { usePermissions } from '../../lib/hooks/usePermissions'

interface HomeDetailsProps {
  property: z.infer<typeof selectPropertyWithAddressSchema>
}

export function HomeDetails({ property }: HomeDetailsProps) {
  const { isOwnerOf } = usePermissions()
  const canEdit = isOwnerOf(property.customerId)

  return (
    <SharedHomeDetails
      property={property}
      propertyHooks={propertyHooks}
      attachmentHooks={attachmentHooks}
      canEdit={canEdit}
    />
  )
}
